import { axiosInstance } from '../api';

export default function(startDate) {
    const adjustedDate = startDate ?? new Date(Date.now());
    const formattedDate = adjustedDate.toISOString();

    return axiosInstance.get(`/fhir/ResearchStudy?status=in-progress&_language=en-CA&recruit-start=gt${formattedDate}&_summary=count`);
}